module.exports = __webpack_public_path__ + "static/media/gps.98a2b1b8.svg";